module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/core-js/library/modules/_add-to-unscopables.js
// module id = 131
// module chunks = 0